import styled from 'styled-components';

export const PixKeySelectContainer = styled.div`
	display: flex;
	width: 100%;
`;
